// @ts-nocheck
export const cytomapStyles = [
    {
        selector: 'node',
        style: {
            shape: 'rectangle',
            content: (e) => {
                if (e.data('color') === '') {
                    return '';
                } else {
                    return '\u2B24' + ' ' + e.data('label');
                }
            },
            color: 'data(color)',
            width: 'data(width)',
            height: 'data(height)',
            'background-color': 'white',
            'background-fit': 'contain',
            'background-image': 'data(imageUrl)',
            'background-width': 'data(width)',
            'background-height': 'data(height)',
            'font-family': 'Tahoma, Geneva, sans-serif',
            'font-size': '14px',
            'text-valign': 'bottom',
            'text-halign': 'center',
            'text-wrap': 'none',
            'text-background-opacity': 1,
            'text-background-color': '#ffffff',
            'text-background-shape': 'rectangle',
            'text-height': 100,
        },
    },

    {
        selector: 'edge',
        css: {
            'curve-style': 'bezier',
            'target-arrow-shape': 'triangle-backcurve',
            'target-arrow-color': '#ff006e',
            content: 'data(label)',
            margin: '20px',
            width: '3px',
            'line-color': '#ff006e',
        },
    },
];
